import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaDownload } from "react-icons/fa";
import axios from "axios";
import { Loading } from "@/pages/Other/Loading";

const CareerSupport = () => {
  const { t } = useTranslation();
  const [careerData, setCareerData] = useState(null);


  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careersupport`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setCareerData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  if (!careerData) {
    return <div><Loading /></div>;
  }

  return (
    <section id="careersupport" className="py-16">
      <div className="max-w-7xl mx-auto px-6 text-left">
        
        <div className="max-w-3xl mb-12">
          <span className="pd-badge mb-4">
            Professional Growth
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
            {careerData.heading}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch">
          {/* Left card */}
          <div className="lg:col-span-5 bg-gradient-to-br from-[#0f2244] to-[#1e3a6e] text-white p-10 rounded-3xl flex flex-col justify-between shadow-xl border border-white/10 relative overflow-hidden group">
            {/* Glow accent */}
            <div className="absolute -bottom-10 -left-10 w-60 h-60 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
            
            <div className="space-y-4 relative z-10">
              <h3 className="text-3xl font-extrabold tracking-tight leading-snug">{careerData.description}</h3>
              <p className="text-blue-100/80 text-sm leading-relaxed font-semibold pt-4">{careerData.details}</p>
            </div>
            
            <div className="relative z-10 pt-10">
              <button className="btn-primary-custom !bg-white !text-blue-900 hover:!bg-blue-50 !shadow-none py-4 px-8 w-full flex items-center justify-center gap-2">
                <FaDownload className="w-4 h-4 text-blue-900" />
                {careerData.button.text}
              </button>
            </div>
          </div>

          {/* Right list */}
          <div className="lg:col-span-7 flex flex-col gap-5 justify-center">
            {careerData?.services?.map((service, index) => (
              <div key={index} className="flex items-center gap-6 p-4 bg-white border border-gray-100 rounded-2xl hover:shadow-md transition-shadow duration-300">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-24 h-16 object-cover rounded-xl shadow-sm border border-gray-100"
                />
                <p className="text-gray-800 font-bold text-sm tracking-wide">{service.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerSupport;
